'use client';

import * as layout from '@ocodelib/compose-layout';
import React from 'react';
import { ContentTabs } from '../components/ContentTabs';
import { PyBasicCodingContent } from '../components/PyBasicCodingContent';
import { PyReplCodingContent } from '../components/PyReplCodingContent';
import type { IPyBasicLayoutConfig } from '../types';
import { PLUGIN_KEYS, PLUGIN_KIND_CONTENT } from './plugin-keys';

export function buildLayout(
  overrideCallback?: (layoutManager: layout.ComposeLayoutManager) => void,
) {
  // blox app의 설정
  const layoutConfig: IPyBasicLayoutConfig = {
    contentTabs: {
      initaialTabKey: 'basic',
      tabs: [
        { key: 'basic', name: '코딩', component: <PyBasicCodingContent /> },
        { key: 'repl', name: 'REPL', component: <PyReplCodingContent /> },
      ],
    },
  };

  const layoutManager = new layout.ComposeLayoutManager();

  function reg(key: string, component: React.ReactElement) {
    return layoutManager.registerPlugin(key, component);
  }

  // 기본 레이아웃 빌드
  // reg(PLUGIN_KEYS.root.topBar, <WorkspaceTopbar backLink="/coding/dashboard" />);
  reg(PLUGIN_KEYS.root.contentTabs, <ContentTabs tabNames={{}} />);

  // 컨텐트탭 레이아웃 빌드
  layoutConfig.contentTabs.tabs.forEach(({ key, component }) => {
    const pluginKey = PLUGIN_KIND_CONTENT + '.' + key; // ex: 'content.blox'
    layoutManager.registerPlugin(pluginKey, component);
  });

  function dispose() {
    // 레이아웃 매니저 종료
    layoutManager.destroy();
  }

  if (overrideCallback) {
    overrideCallback(layoutManager);
  }
  // 디버그용 출력
  debugLayoutManager(layoutManager);

  // 레이아웃 매니저 초기화
  layoutManager.init();

  return {
    dispose,
    result: {
      layoutManager,
      layoutConfig,
    },
  };
}

function debugLayoutManager(layoutManager: layout.ComposeLayoutManager) {
  // 디버그
  for (const kind of layoutManager.pluginKinds) {
    const registry = layoutManager.getPluginRegistry(kind);
    console.log(`buildLayout(): plugin(kind=${kind})`, registry?.plugins());
  }
}
